/* eslint-disable react/jsx-curly-newline */
import { useState, useEffect, useCallback } from 'react';
import { TruperTable } from 'truper-web-react-components';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';

import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import '../../styles/FormTescuchaReadOnly.css';
import { formTables } from '../../constants/tables/formTables';
import ProgressBarComponente from '../molecules/ProgresBarComponente';
import utils from '../../utils';
import useFormularioFiles from '../../hooks/useFormularioFiles';
import FormTescuchaFiles from './FormTescuchaFiles';
import { setFoilCode, setFoilData, setFoilKey } from '../../redux/foil/foilSlice';
import FormularioService from '../../API/FormularioService';
import ScreenLoader from '../atoms/ScreenLoader';
import { FileIcon } from '../atoms/FileIcon';
import localStorageConstants, { getFromLocalStorage } from '../../constants/localstorage';

const PrincipalDataBlock = ({ title = '', body = '', flexBody = true }) => (
  <Row className="mb-3 mt-3">
    <Col size="md" md={6} mb={2}>
      <strong> {title}</strong>
    </Col>
    <Col md={6} className={`word-break-all ${flexBody ? 'd-flex' : ''}`}>
      {body}
    </Col>
  </Row>
);

const DataBlock = ({ title = '', body = '' }) => (
  <Row className="container-fluid mb-1 mt-1 p-0">
    <Col md={6}>{title}</Col>
    <Col md={6} className="word-break-all">
      {body}
    </Col>
  </Row>
);

const FormTescuchaReadOnly = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const classes = useStyles();
  const { foilData, foilCode, foilKey } = useAppSelector(({ foilReducer }) => foilReducer);
  const { isLogged } = useAppSelector(({ adminReducer }) => adminReducer);
  const { uploadFiles } = useFormularioFiles();

  const [filesAttached, setFilesAttached] = useState([]);

  const queryParams = new URLSearchParams(window.location.search);
  const paramCode = queryParams.get('folio') || '';
  const paramKey = queryParams.get('clave') || '';

  const syncFolio = async ({ showLoader = false } = {}) => {
    if (isLogged) {
      return FormularioService.consultaFolioAdmin({
        dispatch,
        folio: paramCode || '',
        showLoader: showLoader || false,
      }).then(response => {
        setFoilCode(dispatch, paramCode);
        setFoilKey(dispatch, paramKey);
        setFoilData(dispatch, response);
        return response;
      });
    }

    return FormularioService.consultaFolio({
      dispatch,
      folio: paramCode || '',
      clave: paramKey || '',
      showLoader: showLoader || false,
    }).then(response => {
      setFoilCode(dispatch, paramCode);
      setFoilKey(dispatch, paramKey);
      setFoilData(dispatch, response);
      return response;
    });
  };

  const uploadNewFiles = () => {
    uploadFiles({
      folio: foilCode,
      clave: foilKey,
      files: filesAttached,
    }).finally(() => {
      setTimeout(() => {
        syncFolio({ showLoader: true });
      }, 300);
    });
  };

  const downloadFiles = useCallback(async file => {
    try {
      const respFile = await fetch(`/context/tescucha/api/v1/admin/legacy/descargar/${file.idArchivo}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getFromLocalStorage(localStorageConstants.token)}`,
          'Content-Type': 'application/octet-stream',
        },
      });

      if (!respFile.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await respFile.blob();
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = urlBlob;
      link.setAttribute('download', file.nombreArchivo);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      console.error('Error downloading files:', error);
    }
  }, []);

  useEffect(() => {
    if (paramCode) {
      syncFolio()
        .then(response => {
          if (!response?.idFolio) history.push(isLogged ? '/bandeja/colaborador' : '/home/colaborador');
        })
        .catch(() => {
          history.push(isLogged ? '/bandeja/colaborador' : '/home/colaborador');
        });
    } else {
      history.push(isLogged ? '/bandeja/colaborador' : '/home/colaborador');
    }
  }, [paramCode, paramKey]);

  if (!foilData) {
    return <ScreenLoader loading />;
  }

  const usrAnonimo = foilData?.usrAnonimo;

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px - 56px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container
        maxWidth="md"
        style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '20px', marginBottom: '20px' }}
      >
        <Box
          sx={{
            padding: 2,
            marginTop: 2,
            width: '100%',
            height: '100%',
            backgroundColor: '#fff',
            borderRadius: '4px',
            paddingY: 5,
            paddingX: 3,
            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
            mb: 2,
          }}
        >
          <Card.Header>
            <>
              {' '}
              <strong className="enfasis">Estimado usuari@,</strong>
              <p>
                Agradecemos su uso del Sistema de Denuncias de TEscucha. Para garantizar su anonimato, pedimos un medio
                de contacto personal para brindar un seguimiento eficiente, obtener más información y resolver sus
                dudas.
              </p>
              <p>
                {' '}
                Le garantizamos que sus datos serán tratados con confidencialidad y seguridad por nuestro equipo
                especializado. Recomendamos guardar el número de folio y clave generada al final de este formulario para
                poder seguir el progreso de su denuncia o mejora a través de nuestra plataforma.
              </p>
            </>

            <ProgressBarComponente />
          </Card.Header>

          <div className="card p-4 fluid" id="formularioFolio">
            <h3 className="ml-0">
              <Row className="container">
                Folio: &nbsp;<span className="color-primary">{foilCode}</span>
                &nbsp;&nbsp;&nbsp; Fecha actual: &nbsp;
                <span className="color-primary">{utils.getDateFormat(new Date(), 'dd/MM/YYY')}</span>
              </Row>
            </h3>
            <div className="separator" />{' '}
            <PrincipalDataBlock
              title="¿Es la primera vez que utiliza TEscucha?"
              body={foilData?.primerDenuncia || '-'}
            />
            <PrincipalDataBlock title="¿Cómo se entero de TEscucha?" body={foilData.medioComunicacion || ' - '} />
            <div className="separator" />
            <PrincipalDataBlock title="Género" body={foilData?.genero || ' -'} />
            <div className="separator" />
            <PrincipalDataBlock title="Tipo de usuario" body={foilData?.tipoUsuario || ' - '} />
            <div className="separator" />
            <PrincipalDataBlock
              title="Tipo de denuncia"
              body={
                <span className="text-capitalize">
                  {usrAnonimo ? `${usrAnonimo ? 'Anonimo' : 'No Anonimo'}` : ' - '}
                </span>
              }
            />
            {usrAnonimo === 'no' && (
              <PrincipalDataBlock
                flexBody={false}
                title=""
                body={
                  <>
                    <DataBlock title="Nombre completo:" body={`${foilData?.usrNombre} ${foilData?.usrApellido}`} />
                    <DataBlock title="Teléfono fijo o celular:" body={foilData?.usrTelefono} />
                    <DataBlock title="Correo electrónico:" body={foilData?.usrCorreo} />
                    <DataBlock title="Puesto:" body={foilData?.usrPuesto} />
                    <DataBlock title="Ubicación:" body={foilData?.usrUbicacion} />
                  </>
                }
              />
            )}
            <div className="separator" />
            {!!foilData.tipoSugerencia && (
              <PrincipalDataBlock title="Tipo de reporte" body={foilData.tipoSugerencia || ' - '} />
            )}
            {!!foilData.tipoDenunciaMejora && (
              <PrincipalDataBlock title="Comportamiento o mejora" body={foilData.tipoDenunciaMejora || ' - '} />
            )}
            {!!foilData.tipoConducta && (
              <PrincipalDataBlock title="Tipo de conducta" body={foilData.tipoConducta || ' - '} />
            )}
            <div className="separator" />
            <PrincipalDataBlock title="Fecha del incidente" body={foilData.fechaEvento} />
            <div className="separator" />
            {!!foilData.ubicacion && (
              <PrincipalDataBlock
                title="Ubicación y el área que deseas reportar o sugerir para mejorar"
                body={foilData.ubicacion || ' - '}
              />
            )}
            {!!foilData.area && <PrincipalDataBlock title="Area de la ubicación" body={foilData.area || ' - '} />}
            {!!foilData.departamento && (
              <PrincipalDataBlock title="Tipo de departamento" body={foilData.departamento || ' - '} />
            )}
            <div className="separator mb-3 page-break-before" />
            <PrincipalDataBlock title="Infractores – Persona(s) que comenten la falta." body="" />
            <Row>
              <Col xs={{ span: 10, offset: 1 }}>
                <div className="TruperTableContainer">
                  <TruperTable
                    selectable={false}
                    alternateRows
                    columnsProperty={formTables.infractor(null, null, true)}
                    dataProperty={
                      Array.isArray(foilData?.listaInv)
                        ? foilData?.listaInv.filter(el => el.tipoInvolucrado === 'Infractor')
                        : []
                    }
                    dynamicHeight={false}
                    rowsDisplayed={100}
                  />
                </div>
              </Col>
            </Row>
            <div className="separator mt-5" />
            <Row className="mb-3 mt-3">
              <Col size="md" md={6}>
                <strong>Comentarios:</strong>
              </Col>
              <Col md={12} className="d-flex text-break">
                {foilData?.txtSituacion || ' - '}
              </Col>
            </Row>
            <div className="separator mb-3" />
            <PrincipalDataBlock
              title="Testigo(s) – Persona(s) que vieron, escucharon y/o saben sobre la situación reportada."
              body=""
            />
            <Row>
              <Col xs={{ span: 10, offset: 1 }}>
                <div className="TruperTableContainer">
                  <TruperTable
                    selectable={false}
                    alternateRows
                    columnsProperty={formTables.testigo(null, null, true)}
                    dataProperty={
                      Array.isArray(foilData?.listaInv)
                        ? foilData.listaInv.filter(el => el.tipoInvolucrado === 'Testigo')
                        : []
                    }
                    dynamicHeight={false}
                    rowsDisplayed={100}
                  />
                </div>
              </Col>
            </Row>
            <div className="separator mt-5" />
            <PrincipalDataBlock title="¿Es usted el afectado directo?" body={foilData?.afectadoDirecto || ' - '} />
            {foilData.afectadoDirecto === 'no' && (
              <Row>
                <Col xs={{ span: 10, offset: 1 }}>
                  <div className="TruperTableContainer">
                    <TruperTable
                      selectable={false}
                      alternateRows
                      columnsProperty={formTables.afectado(null, null, true)}
                      dataProperty={
                        Array.isArray(foilData?.listaInv)
                          ? foilData.listaInv.filter(el => el.tipoInvolucrado === 'Afectado')
                          : []
                      }
                      dynamicHeight={false}
                      rowsDisplayed={100}
                    />
                  </div>
                </Col>
              </Row>
            )}
            <div className="mb-3" />
          </div>
          <div className="separator" />

          {foilData?.archivosPruebas && foilData?.idFolio && (
            <Button variant="truper" size="sm" onClick={() => downloadFiles({ byIdFoil: foilData.idFolio })}>
              <FontAwesomeIcon icon={faDownload} /> &nbsp;&nbsp;Descargar Archivo
            </Button>
          )}

          {!foilData?.archivosPruebas && (
            <>
              <Row className="container-fluid p-4 w-100">
                {!isLogged && (
                  <Col xs className="m-0 w-100">
                    {foilData?.idEstatusDenuncia <= 2 ? (
                      <FormTescuchaFiles
                        onFileAttached={files => setFilesAttached(files)}
                        onUploadAction={uploadNewFiles}
                      />
                    ) : (
                      ''
                    )}
                  </Col>
                )}
                {foilData?.listaArchivos?.length && (
                  <Box sx={{ width: '100%' }}>
                    <Typography variant="h6" color="primary" align="center" gutterBottom>
                      Evidencias cargadas
                    </Typography>
                    <Box className={classes.filesPreviewGrid}>
                      {foilData?.listaArchivos.map((file, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexDirection: 'row',
                            width: '100%',
                            borderRadius: 4,
                            border: '1px solid #D8DCDF',
                            padding: '2px 8px',
                            height: 32,
                            maxHeight: 32,
                            minWidth: 0,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              flexDirection: 'row',
                              gridGap: 2,
                              minWidth: 0,
                              flex: 1,
                              overflow: 'hidden',
                            }}
                          >
                            <FileIcon color="#000" />
                            <Typography variant="body2" color="inherit" className={classes.fileName}>
                              {file.nombreArchivo}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              flexDirection: 'row',
                              flexShrink: 0,
                            }}
                          >
                            <IconButton size="small" onClick={() => downloadFiles(file)}>
                              <GetAppIcon fontSize="small" color="primary" />
                            </IconButton>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Row>
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  filesPreviewGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '32px',
    gap: '4px',
    width: '100%',
    minWidth: 0,
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    minWidth: 0,
  },
}));

export default FormTescuchaReadOnly;
